import Lancely from '@blacksector/lancelyjs';

const lancely = new Lancely({
    apiURL: process.env.REACT_APP_API_URL
});

export default lancely;